import axios from "axios";
import { API_BASE_URL } from "../core/env.configs";
import {
  cleanLocalStorage,
  errorToast,
  getJWTToken,
  getLocalStorageItem,
  setLocalStorageItem,

} from "../utils/helper";

const BASE_URL = API_BASE_URL || "https://staging-api.shoorah.io/";
// const BASE_URL = "http://localhost:3003/";

const GetApi = async (tag = "", isHeader = false, isAdmin = true) => {
  const url = isAdmin ? "admin/v1" : "company/v1";
  try {
    const data = await axios.get(BASE_URL + url + tag, {
      headers: isHeader
        ? {
          Authorization: getJWTToken(),
        }
        : {},
    });
    return data;
  } catch (e) {
    // ErrorHandler(e);
  }
};

const DeleteApi = async (tag = "", isHeader = false, isAdmin = true) => {
  const url = isAdmin ? "admin/v1" : "company/v1";
  try {
    const data = await axios.delete(BASE_URL + url + tag, {
      headers: isHeader
        ? {
          Authorization: getJWTToken(),
        }
        : {},
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const PostApi = async (
  tag = "",
  reqBody,
  isHeader = false,
  flag = false,
  isAdmin = true
) => {
  let flagCheck = flag
    ? "multipart/form-data; boundary=----WebKitFormBoundaryueI4YvrqiXxUgVGA"
    : "application/json";
  const url = isAdmin ? "admin/v1" : "company/v1";
  try {
    const data = await axios.post(BASE_URL + url + tag, reqBody, {
      headers: isHeader
        ? {
          "Content-Type": flagCheck,
          accept: flagCheck,
          Authorization: getJWTToken(),
        }
        : {},
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const PutApi = async (
  tag = "",
  reqBody,
  isHeader = false,
  flag = false,
  isAdmin
) => {
  let flagCheck = flag
    ? "multipart/form-data; boundary=----WebKitFormBoundaryueI4YvrqiXxUgVGA"
    : "application/json";
  const url = isAdmin ? "admin/v1" : "company/v1";
  try {
    const data = await axios.put(BASE_URL + url + tag, reqBody, {
      headers: isHeader
        ? {
          "Content-Type": flagCheck,
          accept: flagCheck,
          Authorization: getJWTToken(),
        }
        : {},
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const ErrorHandler = async (e) => {
  if (e.response?.data?.message) {
    if (e.response?.data?.code === 498) {
      RefreshToken();
    } else if (e.response?.data?.code === 401) {
      errorToast(e.response?.data?.message);
      cleanLocalStorage();
      window.location.href = "/login";
    } else {
      errorToast(e.response?.data?.message);
    }
  } else if (e.response?.data) {
    if (e.response?.data?.meta?.code === 498) {
      RefreshToken();
    } else if (e.response?.data?.code === 401) {
      errorToast(e.response?.data?.message);
      cleanLocalStorage();
      window.location.href = "/login";
    } else {
      errorToast(e.response?.data?.meta?.message);
    }
  } else {
    errorToast("Something went wrong");
  }
};

const RefreshToken = async () => {
  await axios
    .post(
      `${BASE_URL}admin/v1/refresh-token`,
      {},
      { headers: { "refresh-token": getLocalStorageItem("refreshToken") } }
    )
    .then(async (response) => {
      if (response.data.meta.code === 1) {
        setLocalStorageItem("token", response.data.meta.token);
        window.location.reload();
      }
    })
    .catch(async (error) => {
      if (error.response.data.code === 401) {
        cleanLocalStorage();
        window.location.href = "/login";
      } else {
        cleanLocalStorage();
        window.location.href = "/login";
      }
    });
};

const getB2BFansMode = () => {
  return JSON.parse(getLocalStorageItem('isB2BFansMode')) || false;
};
export const surveyApi = {

  getByIdByAdmin: (surveyId, isAdmin) => {
    const isFansMode = getB2BFansMode();
    const url = isAdmin
      ? `/survey?id=${surveyId}`
      : `/survey?id=${surveyId}&isFanMode=${isFansMode}`;
    return GetApi(url, true, isAdmin);
  }
  ,
  getByTemplateByAdmin: (templateId, isAdmin) =>
    GetApi(`/survey?id=${templateId}&type=1`, true, isAdmin),
  getSurveyCategory: (isAdmin) => GetApi("/survey/category", true, isAdmin),
  createSurveyByAdmin: (reqBody, isAdmin) => {
    const isFansMode = getB2BFansMode();
    const body = isAdmin ? reqBody : { ...reqBody, isFanMode: isFansMode };
    return PostApi("/survey", body, true, false, isAdmin);
  },
  editSurveyByAdmin: (reqBody, isAdmin) => {
    const isFansMode = getB2BFansMode();
    const body = isAdmin ? reqBody : { ...reqBody, isFanMode: isFansMode };
    return PutApi("/survey", body, true, false, isAdmin);
  },
  deleteSurvey: (id, isAdmin) => DeleteApi(`/survey?id=${id}`, true, isAdmin),
  getSurveys: (page, perPage, id, type, status, searchKey, date, filterQuery, isAdmin = true) => {
    const isFansMode = getB2BFansMode();
    const url = isAdmin
      ? `/survey?page=${page}&limit=${perPage}&id=${id}&type=${type || ""}&status=${status}&search=${searchKey}&date=${date}`
      : `/survey?page=${page}&limit=${perPage}&id=${id}&type=${type || ""}&status=${status}&search=${searchKey}&date=${date}&isFanMode=${isFansMode}`;
    return GetApi(url, true, isAdmin);
  }
  ,
  getSurveyStatus: (isAdmin, id) => {
    const isFansMode = getB2BFansMode();
    if (isAdmin == true) {
      return GetApi(`/survey/status?companyId=${id}`, true, isAdmin);
    } else {
      return GetApi(`/survey/status?companyId=${id}&isFanMode=${isFansMode}`, true, isAdmin);
    }

  },
  getSurveyResult: (id, isAdmin) => {
    const isFansMode = getB2BFansMode();
    const url = isAdmin
      ? `/survey/results?surveyId=${id}`
      : `/survey/results?surveyId=${id}&isFanMode=${isFansMode}`;
    return GetApi(url, true, isAdmin);
  },
  getSurveyInsights: (id, isAdmin) => {
    const isFansMode = getB2BFansMode();
    const url = isAdmin
      ? `/survey/insights?page=1&perPage=10&id=${id}`
      : `/survey/insights?page=1&perPage=10&id=${id}&isFanMode=${isFansMode}`;
    return GetApi(url, true, isAdmin);
  },
  getSurveyAll: (
    page,
    perPage,
    id,
    type,
    status,
    searchKey,
    date,
    filterQuery
  ) => {
    const isFansMode = getB2BFansMode();
    return GetApi(
      `/survey?page=${page}&limit=${perPage}&id=${id}&type=${type || ""
      }&status=${status}&search=${searchKey}&date=${date}&isFanMode=${isFansMode}`,
      true,
      false
    );
  },
  getAdminList: (userType, isAdmin = true) => {
    const isFansMode = getB2BFansMode();
    const url = isAdmin
      ? `/admins?userType=${userType}&accountStatus=1&page=1&perPage=10`
      : `/admins?userType=${userType}&accountStatus=1&page=1&perPage=10&isFanMode=${isFansMode}`;
    return GetApi(url, true, isAdmin);
  },

  inactiveAdminSurvey: (id, isAdmin) =>
    PutApi(`/survey/inactive-survey?id=${id}`, {}, true, false, isAdmin),
  activeAdminSurvey: (id, isAdmin) =>
    PutApi(`/survey/active-survey?id=${id}`, {}, true, false, isAdmin),
  copySurvey: (body, isAdmin) =>
    PostApi(`/survey/copy`, body, true, false, isAdmin),
};
